import { AuctionDrugItem } from './auction-drug-item';

export class Auction {

  constructor() { }

  code: string;
  contractor: string;
  costAuction: string;
  dateAuction: string;
  dateSubmission: string;
  distributerLogistic: string;
  distributerParticipant: string;
  distributerParticipant2: string;
  distributerParticipant3: string;
  distributerParticipantSAI1: string;
  distributerParticipantSAI2: string;

  distributerWinner: string;
  manager: string;
  region: string;
  status: string;
  parent: string;
  deliveryInformationDate: string;
  typeLow: string;
  typeMail: string;
  authOrganization: string;
  specification: string;
  comment: string;
  primaryContract: string;
  amountPosition: number;
  drugs: AuctionDrugItem[];
  statusST: string;
  iasDataErrorList: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/home/models/auction.ts